// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"util-CopyButton__copyButton--OC0Wa","copied":"util-CopyButton__copied--2WzEC"};